module.exports = __webpack_public_path__ + "media/img/avatars/profiles/avatar-3-7ebbeb044b80b8bb1ce8626737ce881c.jpg";